(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectservicedetailByProjectId', ProjectservicedetailByProjectId);

    ProjectservicedetailByProjectId.$inject = ['$resource', 'DateUtils'];

    function ProjectservicedetailByProjectId ($resource, DateUtils) {
        var resourceUrl =  'api/projectservicedetails/byprojectid/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                        data.lastactiondate = DateUtils.convertDateTimeFromServer(data.lastactiondate);
                        data.statusdate = DateUtils.convertDateTimeFromServer(data.statusdate);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
